export default "__VITE_ASSET__D38bCh6V__"